export default __webpack_public_path__ + "media/images/portfolio/gallery-05-390x230-90c4de94ae8c2020c865244f0810c4e1.jpg";